import { MYGEOTOKENS_WALLET_DISPLAY_NAME } from "@/constants/wallet-branding";

interface WalletHeaderProps {
	connected: boolean;
}

export const WalletHeader: React.FC<WalletHeaderProps> = ({ connected }) => (
	<div className="text-center">
		<h1 className="text-2xl md:text-3xl font-bold mb-2 text-[#FFF1E9]">
			{connected
				? MYGEOTOKENS_WALLET_DISPLAY_NAME
				: `Connect ${MYGEOTOKENS_WALLET_DISPLAY_NAME}`}
		</h1>
		<p className="text-sm md:text-base text-[#918884]">
			{connected
				? `Your ${MYGEOTOKENS_WALLET_DISPLAY_NAME} is connected. View your assets below.`
				: `Connect ${MYGEOTOKENS_WALLET_DISPLAY_NAME} to access your NFT collection.`}
		</p>
	</div>
);
